var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word-hover",style:(`top: ${_vm.y}px; left: ${_vm.x}px;`)},[_c('p',{staticClass:"word"},[_vm._v(_vm._s(_vm.word))]),_c('div',{staticClass:"meanings"},_vm._l((_vm.meanings),function(meaning){return _c('p',[_vm._v(_vm._s(meaning))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }